import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../subscribeCampaignAction';
export function getSubscribeStatus(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_SUBSCRIBE_STATUS
            },
            _a[CALL_API] = {
                endpoint: "/api/gambler/subscriptions",
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_FETCH_SUBSCRIBE_STATUS,
                    ActionTypes.FAILURE_FETCH_SUBSCRIBE_STATUS
                ],
                credentials: true,
                data: data
            },
            _a));
    };
}
export function createSubscribeCampaign(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.CREATE_SUBSCRIBE_CAMPAIGN
            },
            _a[CALL_API] = {
                endpoint: "/api/gambler/subscription",
                method: 'PUT',
                types: [
                    ActionTypes.SUCCESS_CREATE_SUBSCRIBE_CAMPAIGN,
                    ActionTypes.FAILURE_CREATE_SUBSCRIBE_CAMPAIGN
                ],
                credentials: true,
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/bonus/creators/subscribeCampaignAction.js